import React from "react";
import { FormattedMessage } from "react-intl";
import { CONTACT_EMAIL } from "../../constants/email";
import Anchor from "../Anchor";
import styles from "./styles.css";
import Link from "../Link";
const ID = "contacts";
function Contacts() {
    return (React.createElement("section", { className: styles.container },
        React.createElement(Anchor, { id: ID, label: React.createElement(FormattedMessage, { id: "ContactUsTitle" }) }),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ContactUsHelperText" }),
            " – ",
            React.createElement(Link, { href: `mailto:${CONTACT_EMAIL}`, className: styles.email, content: CONTACT_EMAIL }))));
}
;
export default Contacts;
